const BASE = "/api/jeopardy";

async function request(path, options) {
    const res = await fetch(`${BASE}/${path}`, {
        headers: { "Content-Type": "application/json" },
        ...options,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok && data.error === undefined) {
        throw new Error(`Request failed: ${res.status}`);
    }
    return data;
}

export function createRoom(rounds) {
    return request("room.php", { method: "POST", body: JSON.stringify({ rounds }) });
}

export function getRoomState(code) {
    return request(`room.php?code=${encodeURIComponent(code)}`);
}

export function joinRoom(code, name) {
    return request("join.php", { method: "POST", body: JSON.stringify({ code, name }) });
}

export function revealClue(code, hostToken, category, row) {
    return request("reveal.php", {
        method: "POST",
        body: JSON.stringify({ code, hostToken, category, row }),
    });
}

export function showClue(code, hostToken) {
    return request("show_clue.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function openBuzzer(code, hostToken) {
    return request("open_buzzer.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function buzzIn(code, token) {
    return request("buzz.php", { method: "POST", body: JSON.stringify({ code, token }) });
}

export function judgeAnswer(code, hostToken, correct) {
    return request("judge.php", {
        method: "POST",
        body: JSON.stringify({ code, hostToken, correct }),
    });
}

export function closeClue(code, hostToken) {
    return request("close_clue.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function cancelClue(code, hostToken) {
    return request("cancel_clue.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function nextRound(code, hostToken) {
    return request("next_round.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function setScore(code, hostToken, playerId, score) {
    return request("set_score.php", {
        method: "POST",
        body: JSON.stringify({ code, hostToken, playerId, score }),
    });
}

export function finishGame(code, hostToken) {
    return request("finish_game.php", { method: "POST", body: JSON.stringify({ code, hostToken }) });
}

export function listBoards() {
    return request("boards.php");
}

export function getBoard(id) {
    return request(`boards.php?id=${encodeURIComponent(id)}`);
}

export function saveBoard(id, name, rounds) {
    return request("boards.php", { method: "POST", body: JSON.stringify({ id, name, rounds }) });
}

export function deleteBoard(id) {
    return request(`boards.php?id=${encodeURIComponent(id)}`, { method: "DELETE" });
}

export function hostStorageKey(code) {
    return `jeopardy_host_${code}`;
}

export function playerStorageKey(code) {
    return `jeopardy_player_${code}`;
}
